// extracted by mini-css-extract-plugin
module.exports = {"member":"ProfileCard-module--member--2G2yQ","image":"ProfileCard-module--image--8ZOOV","name":"ProfileCard-module--name--113QE","position":"ProfileCard-module--position--3jtKo"};